import React, { type PropsWithChildren } from 'react';
import { View } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const OrdersListOrderContainer = (props: PropsWithChildren) => {
  return <View>{props.children}</View>;
};
